/* eslint-disable */
import React, { useMemo } from "react";
import * as d3 from "d3";

export const SkeletonMarketViewBubbleChart = ({
  width = 1200,
  height = 720,
  bubbleCount = 200,
}) => {
  const bubbles = useMemo(() => {
    const initialBubbles = Array.from({ length: bubbleCount }, (_, i) => {
      let value;
      if (i < 3) value = 300 + Math.random() * 70;
      else if (i < 15) value = 100 + Math.random() * 40;
      else if (i < 40) value = 50 + Math.random() * 20;
      else if (i < 100) value = 15 + Math.random() * 10;
      else value = 6 + Math.random() * 5;
      return {
        id: i,
        value,
        r: Math.sqrt(value) * 3.8,
        x: width / 2 + (Math.random() - 0.5) * width * 0.8,
        y: height / 2 + (Math.random() - 0.5) * height * 0.8,
      };
    });

    const simulation = d3
      .forceSimulation([...initialBubbles])
      .force("x", d3.forceX(width / 2).strength(0.05))
      .force("y", d3.forceY(height / 2).strength(0.05))
      .force(
        "collide",
        d3.forceCollide((d) => d.r + 1)
      )
      .stop();

    for (let i = 0; i < 180; i++) simulation.tick();

    return initialBubbles.map((bubble, i) => ({
      ...bubble,
      x: simulation.nodes()[i].x,
      y: simulation.nodes()[i].y,
    }));
  }, [bubbleCount, width, height]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#000",
      }}
    >
      <svg width={width} height={height}>
        <defs>
          <style>
            {`
              @keyframes loadingPulse {
                0% { fill: #111; transform: translateY(0); }
                25% { fill: #222; transform: translateY(-2px); }
                50% { fill: #2a2a2a; transform: translateY(0); }
                75% { fill: #222; transform: translateY(2px); }
                100% { fill: #111; transform: translateY(0); }
              }

              .loading-bubble {
                animation: loadingPulse 0.8s linear infinite;
                opacity: 0.9;
              }
            `}
          </style>
        </defs>
        <g>
          {bubbles.map((b, i) => (
            <circle
              key={b.id}
              cx={b.x}
              cy={b.y}
              r={b.r}
              className="loading-bubble"
              style={{
                animationDelay: `${Math.random() * 0.8}s`,
              }}
            />
          ))}
        </g>
      </svg>
    </div>
  );
};
